import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import useUserData from 'data-hooks/useUserData';
import { useMutation } from '@apollo/client';
import { GET_FAVORITED_PRODUCT_IDS } from '@/graphql/queries';
import useFavoritedProductIds from 'hooks/useFavoritedProductIds';
import usePdpId from 'components/consumer/PDP/state/context/usePdpId';
import useSetFavoriteModalState from 'global-state/favoriteModalState/useSetFavoriteModalState';
import { FAVORITE_PRODUCT_V2 } from '@/graphql/mutations';
const useProductFavoriteV2 = () => {
  const $ = _c(19);
  const productId = usePdpId();
  const {
    isLoggedIn
  } = useUserData();
  const {
    data
  } = useFavoritedProductIds();
  let t0;
  if ($[0] !== data?.productIds) {
    t0 = data?.productIds ?? [];
    $[0] = data?.productIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const productIds = t0;
  let t1;
  if ($[2] !== productId || $[3] !== productIds) {
    t1 = productIds.includes(productId);
    $[2] = productId;
    $[3] = productIds;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const isFavorited = t1;
  const setFavoriteModalState = useSetFavoriteModalState();
  const t2 = !isFavorited;
  let t3;
  if ($[5] !== productId || $[6] !== t2) {
    t3 = {
      userFavoriteActionV2: {
        id: productId,
        status: t2,
        __typename: "FavResponseV2"
      }
    };
    $[5] = productId;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      query: GET_FAVORITED_PRODUCT_IDS
    }];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = {
      optimisticResponse: t3,
      update: _temp,
      refetchQueries: t4
    };
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const toggleFavoriteMutationOptions = t5;
  const [toggleFavorite] = useMutation(FAVORITE_PRODUCT_V2, toggleFavoriteMutationOptions);
  let t6;
  if ($[11] !== isLoggedIn || $[12] !== productId || $[13] !== setFavoriteModalState || $[14] !== toggleFavorite) {
    t6 = event => {
      event.stopPropagation();
      event.preventDefault();
      if (!productId) {
        return;
      }
      if (!isLoggedIn) {
        setFavoriteModalState({
          productId
        });
      } else {
        toggleFavorite({
          variables: {
            productID: productId
          }
        });
      }
    };
    $[11] = isLoggedIn;
    $[12] = productId;
    $[13] = setFavoriteModalState;
    $[14] = toggleFavorite;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const onFavClick = t6;
  let t7;
  if ($[16] !== isFavorited || $[17] !== onFavClick) {
    t7 = {
      isFavorited,
      onFavClick
    };
    $[16] = isFavorited;
    $[17] = onFavClick;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default useProductFavoriteV2;
function _temp(cache, t0) {
  const {
    data: t1
  } = t0;
  const {
    userFavoriteActionV2
  } = t1;
  const cached = cache.readQuery({
    query: GET_FAVORITED_PRODUCT_IDS
  });
  const favProductIds = cached?.productIds;
  if (!favProductIds) {
    return;
  }
  const newFavoritedProductIds = userFavoriteActionV2?.status ? [...favProductIds, userFavoriteActionV2?.id] : favProductIds.filter(id => id !== userFavoriteActionV2?.id);
  cache.writeQuery({
    query: GET_FAVORITED_PRODUCT_IDS,
    data: {
      productIds: newFavoritedProductIds
    }
  });
}